import PatientReportDialog from './PatientReportDialog';

export default PatientReportDialog;
